export const themeswitchConstants = {
    DARK_MODE: 'DARK_MODE',
    LIGHT_MODE: 'LIGHT_MODE',

    DARK_MODE_NR: 1,
    LIGHT_MODE_NR: 2,
};